import ProductSearchBrandFormView from './ProductSearchBrandFormView';

const initBrandModelTopFacets = () => {
  const productSearchBrandFormViewElem = document.getElementById('product-search-brand-form-view'),
    productSearchBrandFormViewSubmitBtn = document.getElementById('product-search-brand-form-view-submit') as HTMLButtonElement,
    resetFacets = document.getElementById('delete-facet-selection') as HTMLButtonElement;

  if (null === productSearchBrandFormViewElem) {
    return;
  }

  const view = new ProductSearchBrandFormView(
    productSearchBrandFormViewElem,
    false,
    productSearchBrandFormViewSubmitBtn,
    resetFacets,
  );

  view.init();
};

export default initBrandModelTopFacets;

